<app-loader *ngIf="isLoading"></app-loader>

<div class="d-flex justify-content-between align-items-center mb-3">
  <div>
    <h4 class="q-heading">
      <span><img [src]="'IMAGES.BACKARROW'|translate" (click)="goBack()" alt="" class="me-2 cursor-pointer" /></span>
      {{ "SETTINGS.ANTITHEFT" | translate }}
    </h4>
  </div>

  <div>
    <form [formGroup]="restorePublishForm">
      <select class="form-select bg-transparent" formControlName="mobileDeviceName"
        (change)="onMobileDeviceSelect($event)">
        <option *ngFor="let item of mobileDevice" [value]="item.id">
          {{ item.deviceName }}
        </option>
      </select>
    </form>
  </div>
</div>

<div class="relative pb-6">
  <div class="mx-auto d-none d-md-block w-100 relative">
    <div class="tab-content" id="pills-tabContent">
      <div class="tab-pane fade show active" role="tabpanel" aria-labelledby="pills-home-tab">
        <!-- verticle  -->
        <div class="d-flex mt-3">
          <div class="">
            <nav id="sidebar">
              <div
                class="left-0 d-block fixed top-0 bottom-0 overflow-y-auto flex-row flex-nowrap overflow-hidden flex-column align-items-stretch px-0 d-flex flex-wrap align-items-center justify-content-between">
                <ul class="flex-column min-w-100 d-flex list-unstyled me-4 sm-pills" id="pills-tabVertical">
                  <li *ngFor="let item of tabsData; let i = index" (click)="selectedIndex(i, item)"
                    class="align-items-center q-vertical-text cursor-pointer"
                    [ngClass]="selectedI == i ? 'sm-active' : 'sm-inactive'" [hidden]="item.isAutoDialAllowed">
                    <span class="overflow-txt">{{ item.tabsName }}</span>
                  </li>
                </ul>
              </div>
            </nav>
          </div>

          <div class="p-4 q-vertical-content" [ngClass]="
              selectedI === 0
                ? 'content-border-radius'
                : 'rounded-border-radius'
            ">

            <ng-container *ngIf="selectedI === 0">
              <div class="container-fluid text-center">
                <div class="row">
                  <div class="col-md-12 mb-3">
                    <img [src]="'MANAGEDEVICE.AUTOCAPTUREIMG'|translate" class="img-fluid" alt="" />
                  </div>
                  <p class="mb-3">
                    {{ "MANAGEDEVICE.AUTOCAPTUREIMAGETEXT" | translate }}
                  </p>
                </div>
                <ng-container *ngIf="errorMessage">
                  <p class="errMessage">{{ errorMessage }}</p>
                </ng-container>
                <div class="row mb-5">
                  <div class="col-md-12">
                    <button type="button" class="submit-btn bg-orgclr shadow-none me-3 w-auto mw-100"
                      (click)="sendCommand()">
                      {{ "MANAGEDEVICE.TAKEPICTUR" | translate }}
                    </button>
             
                  </div>
                </div>
              </div>
            </ng-container>
            <ng-container *ngIf="selectedI === 1">
              <div class="container-fluid text-center">
                <div class="row">
                  <div class="col-md-12 mb-3">
                    <img [src]="'MANAGEDEVICE.AUDIORECORDIMG'|translate" class="img-fluid" alt="" />
                  </div>
                  <p class="mb-3">
                    {{ "MANAGEDEVICE.AUTOCAPTUREAUDIOTEXT" | translate }}
                  </p>
                </div>
                <ng-container *ngIf="errorMessage">
                  <p class="errMessage">{{ errorMessage }}</p>
                </ng-container>
                <div class="row mb-5">
                  <div class="col-md-12">
                    <button type="button" class="submit-btn bg-orgclr shadow-none me-3 w-auto mw-100"
                      (click)="sendCommand()">
                      {{ "MANAGEDEVICE.AUTOCAPTUREAUDIO" | translate }}
                    </button>
                  </div>
                </div>
              </div>
            </ng-container>
            <ng-container *ngIf="selectedI === 2">
              <div class="container-fluid text-center">
                <div class="row">
                  <div class="col-md-12 mb-3">
                    <img [src]="'MANAGEDEVICE.RECORDVIDEOIMG'|translate" class="img-fluid" alt="" />
                  </div>
                  <p class="mb-3">
                    {{ "MANAGEDEVICE.AUTOCAPTUREVIDEOTEXT" | translate }}
                  </p>
                </div>
                <ng-container *ngIf="errorMessage">
                  <p class="errMessage">{{ errorMessage }}</p>
                </ng-container>
                <div class="row mb-5">
                  <div class="col-md-12">
                    <button type="button" class="submit-btn bg-orgclr shadow-none me-3 w-auto mw-100"
                      (click)="sendCommand()">
                      {{ "MANAGEDEVICE.AUTOCAPTUREVIDEO" | translate }}
                    </button>
                  </div>
                </div>
              </div>
            </ng-container>
            <ng-container *ngIf="selectedI === 3">
              <div class="container-fluid text-center">
                <div class="row">
                  <form [formGroup]="autoDialForm" (ngSubmit)="onSubmit()">
                    <div>
                      <ngx-intl-tel-input [cssClass]="'form-control q-form-control'" [preferredCountries]="[
                          CountryISO.UnitedStates,
                          CountryISO.UnitedKingdom
                        ]" [enableAutoCountrySelect]="false" [enablePlaceholder]="true" [searchCountryFlag]="true"
                        customPlaceholder="Enter Your Mobile Number" [searchCountryField]="[
                          SearchCountryField.Iso2,
                          SearchCountryField.Name
                        ]" [selectFirstCountry]="false" [selectedCountryISO]="CountryISO.India" [maxLength]="15"
                        [phoneValidation]="true" name="phone" type="number" formControlName="mobileNo"
                        (keydown)="removeSpace($event)" (ngModelChange)="onFocusOutMobile($event)"></ngx-intl-tel-input>
                      <ng-container *ngIf="mobileNoWrong">
                        <p class="errMessage">
                          {{ "MANAGEDEVICE.MINANDMAX8" | translate }}
                        </p>
                      </ng-container>
                    </div>
                    <p class="my-3">
                      {{ "MANAGEDEVICE.AUTODIALTXT" | translate }}
                    </p>
                    <ng-container *ngIf="errorMessage">
                      <p class="errMessage">{{ errorMessage }}</p>
                    </ng-container>
                    <div class="row mb-5">
                      <div class="col-md-12">
                        <button type="submit" class="submit-btn bg-orgclr shadow-none me-3 w-auto">
                          {{ "MANAGEDEVICE.AUTODIAL" | translate }}
                        </button>
                      </div>
                    </div>
                  </form>

                </div>

              </div>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="d-block d-md-none">
    <div class="accordion mt-3 faq-accordion" id="accordionExample">
      <div *ngFor="let item of tabsData; let i = index" [hidden]="item.isAutoDialAllowed"
        class="accordion-item bg-white mb-3">
        <div class="accordion-header mb-0" id="headingOne{{ i }}">
          <button class="accordion-button shadow-none collapsed relative p-3 bg-white border-0" type="button"
            data-bs-toggle="collapse" attr.data-bs-target="#collapse_{{ i }}" aria-expanded="false"
            attr.aria-controls="collapseOne{{ i }}" (click)="selectedIndex(i, item)">
            <span class="me-4">{{ item.tabsName }}</span>
          </button>
        </div>
        <div id="collapse_{{ i }}" class="accordion-collapse collapse" attr.aria-labelledby="headingOne{{ i }}"
          data-bs-parent="#accordionExample">
          <div class="accordion-body">
            <ng-container *ngIf="selectedI === 0">
              <div class="container-fluid text-center">
                <div class="row">
                  <div class="col-md-12 mb-3">
                    <img [src]="'MANAGEDEVICE.AUTOCAPTUREIMG'|translate" class="w-200" alt="" />
                  </div>
                  <p class="mb-3">
                    {{ "MANAGEDEVICE.AUTOCAPTUREIMAGETEXT" | translate }}
                  </p>
                </div>
                <ng-container *ngIf="errorMessage">
                  <p class="errMessage">{{ errorMessage }}</p>
                </ng-container>
                <div class="row mb-5">
                  <div class="col-md-12">
                    <button type="button" class="submit-btn bg-orgclr shadow-none me-3 w-auto mw-100"
                      (click)="sendCommand()">
                      {{ "MANAGEDEVICE.AUTOCAPTUREIMAGE" | translate }}
                    </button>
                  </div>
                </div>
              </div>
            </ng-container>
            <ng-container *ngIf="selectedI === 1">
              <div class="container-fluid text-center">
                <div class="row">
                  <div class="col-md-12 mb-3">
                    <img [src]="'MANAGEDEVICE.AUDIORECORDIMG'|translate" class="w-200" alt="" />
                  </div>
                  <p class="mb-3">
                    {{ "MANAGEDEVICE.AUTOCAPTUREAUDIOTEXT" | translate }}
                  </p>
                </div>
                <ng-container *ngIf="errorMessage">
                  <p class="errMessage">{{ errorMessage }}</p>
                </ng-container>
                <div class="row mb-5">
                  <div class="col-md-12">
                    <button type="button" class="submit-btn bg-orgclr shadow-none me-3 w-auto mw-100"
                      (click)="sendCommand()">
                      {{ "MANAGEDEVICE.AUTOCAPTUREAUDIO" | translate }}
                    </button>
                  </div>
                </div>
              </div>
            </ng-container>
            <ng-container *ngIf="selectedI === 2">
              <div class="container-fluid text-center">
                <div class="row">
                  <div class="col-md-12 mb-3">
                    <img [src]="'MANAGEDEVICE.RECORDVIDEOIMG'|translate" class="w-200" alt="" />
                  </div>
                  <p class="mb-3">
                    {{ "MANAGEDEVICE.AUTOCAPTUREVIDEOTEXT" | translate }}
                  </p>
                </div>
                <ng-container *ngIf="errorMessage">
                  <p class="errMessage">{{ errorMessage }}</p>
                </ng-container>
                <div class="row mb-5">
                  <div class="col-md-12">
                    <button type="button" class="submit-btn bg-orgclr shadow-none me-3 w-auto mw-100"
                      (click)="sendCommand()">
                      {{ "MANAGEDEVICE.AUTOCAPTUREVIDEO" | translate }}
                  </button>
                  </div>
                </div>
              </div>
            </ng-container>
            <ng-container *ngIf="selectedI === 3">
              <div class="container-fluid text-center">
                <div class="row">
                  <form [formGroup]="autoDialForm" (ngSubmit)="onSubmit()">
                    <div>
                      <ngx-intl-tel-input [cssClass]="'form-control q-form-control'" [preferredCountries]="[
                          CountryISO.UnitedStates,
                          CountryISO.UnitedKingdom
                        ]" [enableAutoCountrySelect]="false" [enablePlaceholder]="true" [searchCountryFlag]="true"
                        customPlaceholder="Enter Your Mobile Number" [searchCountryField]="[
                          SearchCountryField.Iso2,
                          SearchCountryField.Name
                        ]" [selectFirstCountry]="false" [selectedCountryISO]="CountryISO.India" [maxLength]="15"
                        [phoneValidation]="true" name="phone" type="number" formControlName="mobileNo"
                        (keydown)="removeSpace($event)" (ngModelChange)="onFocusOutMobile($event)"></ngx-intl-tel-input>
                      <ng-container *ngIf="mobileNoWrong">
                        <p class="errMessage">
                          {{ "MANAGEDEVICE.MINANDMAX8" | translate }}
                        </p>
                      </ng-container>
                    </div>
                    <p class="my-3">
                      {{ "MANAGEDEVICE.AUTODIALTXT" | translate }}
                    </p>
                    <ng-container *ngIf="errorMessage">
                      <p class="errMessage">{{ errorMessage }}</p>
                    </ng-container>
                    <div class="row mb-5">
                      <div class="col-md-12">
                        <button type="submit" class="submit-btn bg-orgclr shadow-none me-3 w-auto">
                          {{ "MANAGEDEVICE.AUTODIAL" | translate }}
                        </button>
                      </div>
                    </div>
                  </form>

                </div>

              </div>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>